import { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import axios from 'axios';

const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

const useEmailValidator = (email) => {
	const [emailExists, setEmailExists] = useState(false);

	useEffect(() => {
		let unmounted = false;
		let source = axios.CancelToken.source();

		const fetchData = () => {
			axios({
				method: 'post',
				url: '/api/account/email',
				data: {
					email,
				},
				cancelToken: source.token,
			})
				.then((res) => {
					const response = res.data;
					if (response.statusCode === 0 && !unmounted) {
						setEmailExists(true);
					}
				})
				.catch((err) => {
					const error = err.response;
					if (error && !unmounted) {
						setEmailExists(false);
					}
				});
		};

		if (email && emailRegex.test(String(email).toLowerCase())) {
			fetchData();
		} else {
			setEmailExists(false);
		}

		return () => {
			unmounted = true;
			source.cancel('Cancelling in cleanup');
		};
	}, [email]);

	return emailExists;
};

useEmailValidator.PropTypes = {
	/**
	 * Email address to pass to API
	 */
	email: PropTypes.string,
};

export default useEmailValidator;
